module.exports = __webpack_public_path__ + "static/banner-852202000a827e34f361fb05ad305f37.jpg";